/** Contact phone validation (phone, mobile, WhatsApp). Country code optional; max 15 digits. */

export const MAX_CONTACT_PHONE_DIGITS = 15;
export const MAX_CONTACT_PHONE_INPUT_LEN = 24;

export function cleanContactPhoneInput(value: string): string {
  return value.replace(/[\s\-()]/g, '');
}

export function validateContactPhone(value: string, fieldName = 'Phone'): string | null {
  if (!value.trim()) return null;
  const cleaned = cleanContactPhoneInput(value);
  if (!/^\+?\d+$/.test(cleaned)) {
    return `${fieldName} may only contain digits and an optional leading +`;
  }
  if (cleaned.length > MAX_CONTACT_PHONE_DIGITS) {
    return `${fieldName} must be at most ${MAX_CONTACT_PHONE_DIGITS} digits`;
  }
  return null;
}

export function formatContactPhoneForInput(value: string): string {
  if (value.length <= MAX_CONTACT_PHONE_INPUT_LEN) return value;
  return value.slice(0, MAX_CONTACT_PHONE_INPUT_LEN);
}
